export default __webpack_public_path__ + "static/best-discounts.url-675964b6af0ed850c1dfb7ec72ec9656.svg";